import {Component, Input, OnInit} from '@angular/core';
import {FadeInOutAnimation} from '@helpers/animations/fadeInOut.animation';
import {EventsService} from '@services/events.service';
import {concatMap, delay, tap} from 'rxjs/operators';
import {of} from 'rxjs';

/**
 *
 */

@Component({
    selector: 'page-preloader',
    template: `
    <div *ngIf="!hiddenStatus" class="page-preloader" [@fadeInOut]>
        <div class="page-preloader__content">
            <div class="page-preloader__logo"><img src="/images/logo-white.svg"/></div>
            <div class="page-preloader__icon"><img src="/images/nk365-preloader.gif"/></div>
            <div *ngIf="message" class="page-preloader__message">{{message}}</div>
        </div>
    </div>`,
    animations: [FadeInOutAnimation]
})
export class PagePreloaderComponent implements OnInit {
    message = '';

    private hidden = true;

    /**
     * Время последнего открытия прелоадера в милисекундах
     * Нужно для рассчета минимальной задержки перед закрытием, чтобы не было эпилептического моргания
     */
    private lastShowTime: number;

    /**
     * Насколько задержать закрытие прелоадера
     */
    private hideDelay = 0;

    /**
     * минимальное время отображения прелоадера перед закрытием, чтобы не происходило слишком быстрого скрытия или эффекта моргания
     * от того, что прелоадер открылся и через долю секунды скрылся
     */
    private minimumShowTime = 1000;

    constructor(
        private events: EventsService,
    ) {

    }

    ngOnInit() {
        this.events.pagePreloaderShow$.subscribe((message: string) => {
            this.message = message;
            this.show();
            /**
             * Запоминаем, когда открывали прелоадер последний раз
             */
            this.lastShowTime = Date.now();
        });

        this.events.pagePreloaderHide$.pipe(
            tap(() => {
                /**
                 * Вычисляем задержку закрытия прелоадера, чтобы обеспечить минимальное время отображения прелоадера
                 */
                const diff = Date.now() - this.lastShowTime;
                this.hideDelay = this.lastShowTime && (diff < this.minimumShowTime) ? this.minimumShowTime - diff : 0;
            }),
            concatMap(value => of(value).pipe(delay(this.hideDelay)))
        ).subscribe(() => {
            this.hide();
        });
    }

    get hiddenStatus() {
        return this.hidden;
    }

    private show() {
        document.body.classList.add('modal-open');
        this.hidden = false;
    }


    private hide() {
        document.body.classList.remove('modal-open');
        this.hidden = true;
    }


    private toggle() {
        this.hidden = !this.hidden;
    }
}
